import styled, { keyframes } from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';
import { Container } from 'components/Grid';
import { screen } from '@/helpers/screen';

export const AwardsWrapper = styled.aside`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 130px;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 1});

  &::before,
  &::after {
    content: '';
    display: block;
    height: 100%;
    width: 200px;
    position: absolute;
    top: 0;
    z-index: 2;
  }

  &::before {
    left: 0;
    background: linear-gradient(
      to left,
      rgba(255, 255, 255, 0),
      rgba(${getToken('color-background-primary')})
    );
  }
  &::after {
    right: 0;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(${getToken('color-background-primary')})
    );
  }
`;

export const ContainerTag = styled(Container)`
  text-align: center;
  margin: 20px auto 0;
`;

export const Tag = styled.div`
  font-family: ${getToken('font-family-title')};
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 2.4px;
  margin: 16px auto;

  color: rgba(${getToken('color-brand')});

  ${screen.xxlg} {
    font-size: 14px;
  }
`;

export const TagLine = styled.h3`
  margin: 8px auto;
  font-family: ${getToken('font-family-default')};
  font-weight: 300;
  font-size: 20px;
  line-height: 100%;
  text-align: center;

  color: rgb(${getToken('color-neutral-60')});
`;

const logosScroll = keyframes`
    0%{
      transform: translateX(0);
    }
    100%{
      transform: translateX(-100%);
    }
`;

export const LogosSlider = styled.div`
  width: 100%;
  overflow: hidden;
  display: inline-flex;
`;

export const LogosList = styled.div`
  display: inline-flex;
  justify-content: space-between;

  animation: ${(props) => props.items}s ${logosScroll} infinite linear;
`;

export const Logo = styled.div`
  height: auto;
  width: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-right: 1px solid rgba(${getToken('color-neutral-60')}, 0.5);
  text-align: center;
  margin: 12px 0;
  padding: 4px 32px;

  .year {
    font-family: ${getToken('font-family-title')};
    font-weight: 700;
    font-size: 11px;
    line-height: 100%;
    letter-spacing: 14%;
    color: rgb(${getToken('color-brand')});
  }

  .title {
    font-family: ${getToken('font-family-title')};
    font-weight: 700;
    font-size: 14px;
    line-height: 130%;
    margin: 6px auto;
    color: rgb(${getToken('color-text-primary')});
  }

  .source {
    font-family: ${getToken('font-family-default')};
    font-weight: 200;
    font-size: 11px;
    line-height: 130%;
    color: rgb(${getToken('color-neutral-60')});
  }
`;
